import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-right-rectangle-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round" },
        React.createElement("path", { d: "M3.5 6.5v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-2" }),
        React.createElement("path", { strokeLinejoin: "round", d: "m7.5 10.5 2-2-2-2m2 2h-8" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
